import type { CollectionItemModel } from "metabase-types/api";

export const COLLECTION_PAGE_SIZE = 25;
export const ALL_MODELS: CollectionItemModel[] = [
  "dashboard",
  "dataset",
  "card",
  "metric",
  "snippet",
  "collection",
];
